import content from '../../locales/en/content.json';
import { primaryPages } from './primary';
import { secondaryOnePages } from './secondaryOne';
import { secondaryTwoPages } from './secondaryTwo';
import { signerPages } from './signer';
import { veteranPages } from './veteran';

export const chapters = {
  veteranInfo: {
    title: content['vet-info-title--chapter'],
    pages: veteranPages,
  },
  primaryCaregiverInfo: {
    title: content['primary-info-title--chapter'],
    pages: primaryPages,
  },
  secondaryCaregiverInfo: {
    title: content['secondary-one-info-title--chapter'],
    pages: {
      ...secondaryOnePages,
      ...secondaryTwoPages,
    },
  },
  signerInfo: {
    title: content['sign-as-rep-title--chapter'],
    pages: signerPages,
  },
};
